import { READ_PERMISSION, REVENUE_DATA } from '../../../common/support/accessControlConstants';
import { hasAccess } from '../../../common/support/utils/accessControlHelpers';
import type { AccessResourcePermissions } from '../../../main/types/accessControlTypes';
export const filterSelectedColumns = (
  pageState: Record<string, any>,
  accessControlData?: AccessResourcePermissions | null
) => {
  const hasRevenueDataAccess = hasAccess([REVENUE_DATA], READ_PERMISSION, accessControlData);
  const hasRevenueColumnsSelected =
    pageState &&
    pageState.selectedColumns &&
    pageState.selectedColumns.find((col) => col.key === 'revenue' || col.key === 'revenue_in_local_currency');

  if (!hasRevenueDataAccess && hasRevenueColumnsSelected) {
    const processedPageState = { ...pageState };
    processedPageState.selectedColumns = processedPageState.selectedColumns.filter(
      (col) => col.key !== 'revenue' && col.key !== 'revenue_in_local_currency'
    );
    return processedPageState;
  }

  return pageState;
};
